import { Icon } from '@aibees/shared/components';
import { MotionContainer, varBounce } from '@aibees/shared/components/animate';
import { CompactLayout } from '@aibees/shared/layouts';
import { Button, Stack, Typography } from '@mui/material';
import { m } from 'framer-motion';
import { Link } from 'react-router-dom';
import * as Styled from './styles';

export default function NotFoundView() {
  return (
    <CompactLayout>
      <MotionContainer>
        <Styled.NotFoundContainer>
          <Stack gap={2} alignItems="center">
            <Styled.Img src="assets/images/404-b2b.svg" alt="logo" />

            <Typography variant="h6" fontWeight={700} color="grey.800">
              Sorry, Page Not Found
            </Typography>

            <Typography variant="body3" fontWeight={500} color="grey.500">
              The page you’re looking for doesn’t exist, has been moved, or the
              URL might be incorrect.
            </Typography>
          </Stack>
          <div>
            <m.div variants={varBounce().in}>
              <Link to="/">
                <Button
                  variant="contained"
                  size="medium"
                  color="primary"
                  startIcon={<Icon name="arrow-left-fill" />}
                >
                  Back to Dashboard
                </Button>
              </Link>
            </m.div>
          </div>
        </Styled.NotFoundContainer>
      </MotionContainer>
    </CompactLayout>
  );
}
